import React from "react";

import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import { withRouter } from "react-router";
import { Button } from "@material-ui/core";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

function AdminLogout(props) {
  const { logoutOpen, handleLogoutClose } = props;
  const { request } = useApi();
  const auth = useAuth();

  const logout = () => {
    request({
      method: "GET",
      url: `admin/authentication/logout`,
    })
      .then((data) => {
        handleLogoutClose(false);
        auth.logout();
        props.history.push("/admin");
      });
  };
  return (
    <Dialog open={logoutOpen} onClose={() => handleLogoutClose(false)}>
      <DialogContent>
        <DialogContentText>ログアウトしますか？</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={logout}>
          はい
        </Button>
        <Button color="primary" onClick={() => handleLogoutClose(false)}>
          いいえ
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default withRouter(AdminLogout);
